// @flow
import React from "react";

export default function Shield() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 38.828 42.107"
    >
      <defs>
        <filter
          id="a"
          x="0"
          y="0"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dy="3" />
          <feGaussianBlur stdDeviation="3" result="b" />
          <feFlood floodOpacity="0.161" />
          <feComposite operator="in" in2="b" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g transform="matrix(1, 0, 0, 1, 0, 0)" filter="url(#a)">
        <path
          d="M-7155.075-6085.915l13.536-13.536v6.471a7.524,7.524,0,0,1-3.355,6.27l-5.687,3.79Zm-6.045-.55,19.093-19.093,1.735,1.735-19.091,19.093Zm1.692-4.817a7.526,7.526,0,0,1-.193-1.7v-10.282h.28a11.976,11.976,0,0,0,8.523-3.529l.236-.237.237.237a11.994,11.994,0,0,0,3.841,2.583l-12.924,12.925Z"
          transform="translate(7170.12 6113.03)"
          fill="#fff"
        />
      </g>
    </svg>
  );
}



// WEBPACK FOOTER //
// ./src/components/Icons/Shield.js